import { clearAllRememberedListState } from "./listReturnNavigation";

const USER_KEY = "userElwnsh";
const TOKEN_KEY = "token";

export const SESSION_EXPIRED_MESSAGE_AR = "انتهت الجلسة";

/** @param {unknown} message */
export function isSessionExpiredMessage(message) {
  if (!message || typeof message !== "string") return false;
  const trimmed = message.trim();
  if (!trimmed) return false;
  if (trimmed === SESSION_EXPIRED_MESSAGE_AR) return true;
  if (trimmed.includes(SESSION_EXPIRED_MESSAGE_AR)) return true;
  const lower = trimmed.toLowerCase();
  return (
    lower.includes("session expired") ||
    lower.includes("session has expired") ||
    lower === "unauthenticated"
  );
}

/** @param {unknown} data */
export function isSessionExpiredPayload(data) {
  if (!data || typeof data !== "object") return false;
  if (data.status === false && isSessionExpiredMessage(data.message)) return true;
  return isSessionExpiredMessage(data.message);
}

/** نقل جلسة قديمة من sessionStorage إلى localStorage مرة واحدة */
export function migrateLegacySessionStorage() {
  try {
    if (!localStorage.getItem(USER_KEY) && sessionStorage.getItem(USER_KEY)) {
      localStorage.setItem(USER_KEY, sessionStorage.getItem(USER_KEY));
      sessionStorage.removeItem(USER_KEY);
    }
    if (!localStorage.getItem(TOKEN_KEY) && sessionStorage.getItem(TOKEN_KEY)) {
      localStorage.setItem(TOKEN_KEY, sessionStorage.getItem(TOKEN_KEY));
      sessionStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    /* private mode / quota */
  }
}

function parseStoredUser(raw) {
  if (!raw || typeof raw !== "string") return null;
  try {
    const u = JSON.parse(raw);
    return u && typeof u === "object" ? u : null;
  } catch {
    return null;
  }
}

export function getStoredUser() {
  migrateLegacySessionStorage();
  return parseStoredUser(localStorage.getItem(USER_KEY));
}

/** التوكن من المفتاح المستقل أو من داخل كائن المستخدم */
export function getStoredToken() {
  migrateLegacySessionStorage();
  const fromKey = localStorage.getItem(TOKEN_KEY);
  if (fromKey != null && String(fromKey).trim() !== "") {
    return String(fromKey).trim();
  }
  const user = parseStoredUser(localStorage.getItem(USER_KEY));
  const embedded = user?.token;
  if (embedded != null && String(embedded).trim() !== "") {
    return String(embedded).trim();
  }
  return null;
}

/** جلسة محلية صالحة: userElwnsh JSON صالح + توكن غير فارغ */
export function hasLocalAuthSession() {
  return Boolean(getStoredUser() && getStoredToken());
}

export function saveAuthSession(userData) {
  if (!userData || typeof userData !== "object") return;
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    if (userData.token != null && String(userData.token).trim() !== "") {
      localStorage.setItem(TOKEN_KEY, String(userData.token).trim());
    }
  } catch {
    /* ignore */
  }
}

export function clearAuthSession() {
  try {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
  clearAllRememberedListState();
}
